import { useState, useEffect } from 'react'
import Team from '../lib/Team.js'

const useTeam = (callback = () => {}) => {
  const [team, setTeam] = useState(null)
  const updateState = (payload) => {
    setTeam((prevValues) => ({ ...prevValues, ...payload.team }))
  }

  useEffect(() => {
    Team.watch({ setState: updateState })
  }, [])

  useEffect(() => {
    if (team) {
      callback(team)
    }
  }, [team])

  return { team }
}

export default useTeam
